/* THIS FILE IS GENERATED ON RUNTIME. DO NOT EDIT */

module.exports = { 
  typography: ["headline-3xl","headline-2xl","headline-xl","headline-lg","headline-md","headline-sm","headline-xs","headline-2xs","headline-3xs","tag-sm","preamble-lg","preamble-md","preamble-sm","body-lg","body-md","body-sm","body-xs","kicker-sm","input-lg","input-md","input-sm","input-xs","quote-md","quote-sm"],
  prose: ["author-details","factbox","coverbox"],
};